/**
 * Journal Analytics sagas
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { httpRequest } from '../../services/http-service';
import { endPoints } from '../../services/endpoints';
import {
  fetchJournalAnalytics,
  setJournalAnalytics,
  setLoading,
  setError,
} from './journalAnalyticsSlice';
import { presentLoader, dismissLoader } from './commonSlice';

/**
 * Fetch journal analytics saga
 */
function* fetchJournalAnalyticsSaga(): Generator<any, void, any> {
  try {
    yield put(presentLoader());
    yield put(setLoading(true));

    const response = yield call(httpRequest.get, endPoints.dashboard.journalAnalytics);

    if (response?.success) {
      yield put(setJournalAnalytics(response.data));
    } else {
      toast.error('Failed to fetch journal analytics');
      yield put(setError('Failed to fetch journal analytics'));
    }
  } catch (error: any) {
    const message = error?.message || 'Failed to fetch journal analytics';
    toast.error(message);
    yield put(setError(message));
  } finally {
    yield put(setLoading(false));
    yield put(dismissLoader());
  }
}

export function* journalAnalyticsSagas(): Generator<any, void, any> {
  yield takeLatest(fetchJournalAnalytics, fetchJournalAnalyticsSaga);
}

